import React from 'react';

// Billing banner removed - replaced with notification system
const BillingBanner: React.FC = () => {
  return null;
};

export default BillingBanner;
